module.exports = __webpack_public_path__ + "assets/imgs/achs/gppa.4f930f0a16488e77f6162655e27d67a3.png";